import script from "./countdownTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./countdownTimer.vue?vue&type=script&setup=true&lang=js"

import "./countdownTimer.vue?vue&type=style&index=0&id=42a5d027&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a5d027"]])

export default __exports__